import Command from '@ckeditor/ckeditor5-core/src/command';

export default class ScribensPluginCommand extends Command {
  constructor(view) {
    super(view);

    this.set({
      isBusy: false,
      isInitialized: false,
    });
  }
  
  refresh() {
    this.isEnabled = !this.isBusy;
  }

  execute(options = {}) {
    if (this.isBusy) {
      return;
    }

    if (!this.isInitialized) {
      const editor = this.editor;
      window.ckeditor_scribens_check(editor.editing.view.getDomRoot(), options);

      this.isInitialized = true;
    }
  }
}